import React, { Fragment, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../Services/translation';
import NewsletterSignUpForm from './NewsletterSignUpForm'

const NewsletterSignUpModal = () => {
    const newsletterSignUpModal = useSelector((state) => state.newsletterSignUpModal);
    const [showConfirm, setShowConfirm] = useState(false);
    const [showContent, setShowContent] = useState(false);
    const dialogRef = useRef(null);
    const cookieName = "newsletter-popup-inactive";

    const closeModal = () => {
        setCookie();
        dialogRef.current.close();
    };

    const setCookie = () => {
        const date = new Date();
        const days = 90;
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        let expires = "; expires=" + date.toUTCString();
        document.cookie = cookieName + "=" + Date.now() + expires + "; path=/; Secure; SameSite=Lax;";
    };
    
    const getCookieValue = () => {
        const nameEq = cookieName + "=";
        const ca = document.cookie.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i].trim();
            if (c.indexOf(nameEq) === 0) {
                return c.substring(nameEq.length, c.length);
            }
        }
        return null;
    }

    const onSubmittedForm = () => {
        setShowConfirm(true);
        setCookie();
        pushToDataLayer('newsletterSubscriptionSubmit');
    }

    return (
        <Fragment>
            {!getCookieValue() &&
                <dialog id="newsletterSignUpModalDialog" ref={dialogRef} className="dialog-floating" open>
                    <div>
                        <div className="newsletter-modal">
                            {newsletterSignUpModal.imageUrl &&
                                <div className="newsletter-modal__image">
                                    <img src={newsletterSignUpModal.imageUrl} />
                                </div>
                            }
                            <div className="newsletter-modal__wrapper">
                                <button className="newsletter-modal__close" onClick={() => closeModal()}><i className="icon-cancel"></i></button>
                                {!showConfirm ? (
                                    <Fragment>
                                        <div className="newsletter-modal__header">
                                            {newsletterSignUpModal.title &&
                                                <span>{newsletterSignUpModal.title}</span>
                                            }
                                            {newsletterSignUpModal.modalContent?.value &&
                                                <button className="newsletter-modal__header__toggle" onClick={() => setShowContent(!showContent)}>
                                                    {showContent ? (
                                                        <Fragment>{translate('js.newslettersignup.modal.togglecontent.hide')}</Fragment>
                                                    ) : (
                                                        <Fragment>{translate('js.newslettersignup.modal.togglecontent.show')}</Fragment>
                                                    )}
                                                </button>
                                            }
                                        </div>
                                        {newsletterSignUpModal.modalContent?.value &&
                                            <div className={`newsletter-modal__content ${!showContent ? 'newsletter-modal__content--hide' : ''}`} dangerouslySetInnerHTML={ {__html: newsletterSignUpModal.modalContent.value} } />
                                        }
                                        <NewsletterSignUpForm onSubmitted={() => onSubmittedForm()} signupComponentName={"NewsletterSubscriptionPopup"} />
                                        {newsletterSignUpModal.privacyPolicyLinkAndTextHtml &&
                                            <div className="newsletter-modal__bottom" dangerouslySetInnerHTML={ {__html: newsletterSignUpModal.privacyPolicyLinkAndTextHtml} } />
                                        }
                                    </Fragment>
                                ) : (
                                    <div className="newsletter-modal__submit-message">
                                        {newsletterSignUpModal.onSuccessfulSubmitMessage &&
                                            <Fragment>
                                                <i className="icon-check_circle newsletter-modal__icon" />{newsletterSignUpModal.onSuccessfulSubmitMessage}
                                            </Fragment>
                                        }
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </dialog>
            }
        </Fragment>
    );
};

export default NewsletterSignUpModal;
